import {mapSearchRoutes} from '../../home-page/shared/services/home-page-helper';
import {routerActions} from 'react-router-redux';

export const onHeaderSearch = (searchBy, query) =>
    dispatch => {

        dispatch(routerActions.push(mapSearchRoutes(searchBy, query)));

    };



// WEBPACK FOOTER //
// ./src/app/action-creators/header-search.js